module.exports = __webpack_public_path__ + "media/images/gallery/open_clusters/M_44/M_44_vis-24f59632526002bdc7240acfd51f8ccb.jpg";